<nav class="fg-sidebar" [class.open]="sidebarOpen">

  <!-- Logo -->
  <div class="fg-sb-logo">
    <a routerLink="/" class="fg-sb-logo-link">
      <div class="fg-sb-logo-icon">
        <img src="assets/images/LOGO_VARIACIONES-03.png" alt="Fogón" class="fg-sb-logo-img fg-sb-logo-img--light">
        <img src="assets/images/LOGO_VARIACIONES-blanco.png" alt="Fogón" class="fg-sb-logo-img fg-sb-logo-img--dark">
      </div>
      <!-- <div class="fg-sb-logo-txt">
        <strong>EL FOGÓN</strong>
        <small>Chicken Grill</small>
      </div> -->
    </a>
  </div>

  <!-- Menu sections -->
  <div class="fg-sb-scroll">

    <ng-container *ngFor="let item of menuItems">

      <!-- Section title -->
      <div class="fg-sb-section" *ngIf="item.isTitle">
        <div class="fg-sb-lbl">{{ item.label }}</div>
      </div>

      <!-- Menu item without subitems -->
      <div class="fg-sb-section" *ngIf="!item.isTitle && !hasItems(item)">
        <a class="fg-sb-item" [routerLink]="item.link" [class.active]="isActive(item.link)">
          <span class="fg-sb-ico" *ngIf="item.icon">
            <img [src]="'assets/svg/' + item.icon + '.svg'" class="fg-sb-svg">
          </span>
          <span>{{ item.label }}</span>
          <span class="fg-sb-badge" *ngIf="item.badge">{{ item.badge.text }}</span>
        </a>
      </div>

      <!-- Menu item with subitems -->
      <div class="fg-sb-section" *ngIf="!item.isTitle && hasItems(item)">
        <div class="fg-sb-item" [class.active]="isParentActive(item)" [class.open]="isSubmenuOpen(item)"
          (click)="toggleSubmenu(item)">
          <span class="fg-sb-ico" *ngIf="item.icon">
            <img [src]="'assets/svg/' + item.icon + '.svg'" class="fg-sb-svg">
          </span>
          <span>{{ item.label }}</span>
          <span class="fg-sb-toggle">&#9662;</span>
        </div>

        <!-- Submenu -->
        <div class="fg-sb-sub" [class.open]="isSubmenuOpen(item)">
          <a class="fg-sb-sub-item" *ngFor="let sub of item.subItems" [routerLink]="sub.link"
            [class.active]="isActive(sub.link)">
            <span class="fg-sb-sub-dot"></span>
            <span>{{ sub.label }}</span>
          </a>
        </div>
      </div>

    </ng-container>

  </div>

  <!-- User card at bottom -->
  <div class="fg-sb-bottom">
    <div class="fg-sb-user">
      <div class="fg-sb-av">{{ userInitial }}</div>
      <div class="fg-sb-uinfo">
        <span class="fg-sb-uname">{{ userName }}</span>
        <span class="fg-sb-urole">{{ userRole }}</span>
      </div>
    </div>
  </div>

</nav>

<!-- Overlay for mobile -->
<div class="fg-sidebar-overlay" [class.show]="sidebarOpen" (click)="closeSidebar()"></div>